import { color as d3color } from 'd3-color';
import color from 'client/utils/constants/GDS/js/color';
import { Fill, Stroke, Style } from 'ol/style';
import { pointStyle } from './aoiStyle';
import { createBufferedStyles } from './bufferedStyle';

const validColorD3 = d3color(color.green);

export const LINESTRING_OUTLINE_DASH = [8, 6];
export const DEFAULT_BUFFER_RADIUS_METRES = 10;

const DEFAULT_STROKE_WIDTH_PX = 2;
const DEFAULT_LINESTRING_BUFFER_WIDTH_PX = 20;
const DEFAULT_FILL_OPACITY = 0.2;

export const validStroke = new Stroke({
    color: validColorD3.toString(),
    width: DEFAULT_STROKE_WIDTH_PX,
    lineCap: 'round',
    lineJoin: 'round'
});

export const validStrokeDashed = new Stroke({
    color: validColorD3.toString(),
    width: DEFAULT_STROKE_WIDTH_PX,
    lineDash: LINESTRING_OUTLINE_DASH,
    lineCap: 'butt',
    lineJoin: 'round'
});

// Kept as an export for parity with the POC and potential external usage.
// Note: the buffered LineString rendering uses polygon buffering (see `createBufferedStyles`).
export const lineStringBufferStroke = new Stroke({
    color: validColorD3.copy({ opacity: DEFAULT_FILL_OPACITY }).toString(),
    width: DEFAULT_LINESTRING_BUFFER_WIDTH_PX,
    lineCap: 'round',
    lineJoin: 'round'
});

export const validFill = new Fill({
    color: validColorD3.copy({ opacity: DEFAULT_FILL_OPACITY }).formatRgb()
});

const getValidStylesForBuffer = (bufferRadiusMetres = DEFAULT_BUFFER_RADIUS_METRES) => {
    const bufferedLineStringStyles = createBufferedStyles({
        bufferRadiusMetres,
        bufferFill: validFill,
        bufferBorderStroke: validStrokeDashed,
        centerStroke: validStroke,
        // If buffer geometry creation fails (JSTS edge cases), fall back to dashed stroke.
        fallbackBufferStroke: validStrokeDashed
    });

    const styles = {
        draw: {
            Point: pointStyle,
            LineString: bufferedLineStringStyles,
            MultiLineString: bufferedLineStringStyles,
            Polygon: new Style({
                fill: validFill
            }),
            Circle: new Style({
                fill: validFill,
                stroke: validStroke
            })
        },
        modify: {
            Point: pointStyle,
            LineString: bufferedLineStringStyles,
            MultiLineString: bufferedLineStringStyles,
            Polygon: new Style({
                fill: validFill,
                stroke: validStroke
            }),
            Circle: new Style({
                fill: validFill,
                stroke: validStroke
            })
        }
    };
    return styles;
};

export const getValidDrawStyle = (bufferRadiusMetres) => getValidStylesForBuffer(bufferRadiusMetres).draw;
export const getValidModifyStyle = (bufferRadiusMetres) => getValidStylesForBuffer(bufferRadiusMetres).modify;

export const validDrawStyle = getValidDrawStyle();
export const validModifyStyle = getValidModifyStyle();
